import { Injectable, Inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Injectable({
    providedIn: 'root',
  })
  export class OktaAuthTokenService {
    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) 
    { }

    get AccessToken() {
        return this.oktaAuth.getAccessToken();
    }

    get User() {
        return this.oktaAuth.getUser();
    }

    signOut() {
        this.oktaAuth.signOut();
    }
  }